import React from "react";
import useTableData from "./useTableData";
import "./_static/listViews.css";
import ListViewCommon from "./ListViewCommon";

const headers = [
    {"label": "Meno", 'caption': "Názov", 'filter': 'string'},
    {"label": "Hlavna_Adresa", 'caption': "Hlavná Adresa", 'filter': 'string'}
]

function Companies(props) {
    const initialFilters = [
        {
            'label': 'Meno',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'Hlavna_Adresa',
            'lookup': '',
            'value': '',
        },
        {
            'label': 'ordering',
            'lookup': '',
            'value': 'Nazov',
        }
    ]

    const baseUrl = '/company/companies'
    const baseUrlFrontend = '/companies/company'
    const [data, filters, filterUpdate, links, delete_single] = useTableData(baseUrl, initialFilters, parse_links)

    function parse_links(newData) {
        return newData.map(entry => ({
            'Meno': `${baseUrlFrontend}/${entry.id}`
        }))
    }

    return (
        <ListViewCommon baseUrlFrontend={baseUrlFrontend}
                        filters={filters}
                        filterUpdate={filterUpdate}
                        links={links}
                        headers={headers}
                        data={data}
                        delete_single={delete_single}
                        label={"Zákazníci"}
        />
    )
}

export default Companies
